const BASE_API_URL = "https://dserver.tradebid.click";
// const BASE_API_URL = "http://localhost:8080";

const BASE_DOMAIN = "https://demo.tradebid.click";
// const BASE_DOMAIN = "http://localhost:6969";

export { BASE_API_URL, BASE_DOMAIN };